@use '@itm/shared-frontend/lib/assets/styles/bulma/shared' as *;
@use './Layout.module.scss' as *;

.Wrapper {
  width: $collapsed-sidebar-width;
  border-right: 1px solid $border;

  &.IsActive {
    width: $active-sidebar-width;
  }

  &:hover .ToggleButton,
  &:focus-within .ToggleButton {
    opacity: 1;
    z-index: 1;
  }
}

.Header {
  padding: 28px 25px;
  border-bottom: 1px solid $border;
}

.Logo {
  display: block;
  width: 60px;
  height: 60px;
  padding: 4px;
  border: 1px solid $grey-lighter;
  border-radius: 5px;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
.ToggleButton {
  position: absolute;
  top: 200px;
  right: 0;
  transform: translateX(50%);
  background-color: $white;
  border: 1px solid $grey-lighter;
  border-radius: 50% !important;
  cursor: pointer;
  letter-spacing: -2px;
  opacity: 0;
  z-index: -1;
  transition: all 0.2s ease !important;
  &:global(:not(.is-active)) {
    :global(.icon) {
      transform: rotateY(180deg);
    }
  }
}
